import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import queryClient from '../query-client';

type GetDownloadLinkResponse = {
    urls: { recordId: string; url: string }[];
};

async function getDownloadLink(recordIds: string[]): Promise<GetDownloadLinkResponse> {
    const { data } = await api.get('/file-records/documents/download', {
        params: {
            recordIds,
        },
    });
    return data;
}

export function useDownloadLink(recordIds: string[], enabled: boolean): UseQueryResult<GetDownloadLinkResponse, unknown> {
    return useQuery(['download-links', ...recordIds], () => getDownloadLink(recordIds), {
        enabled,
        cacheTime: 0,
        retry: false,
        onSettled: () => {
            queryClient.invalidateQueries(['file-records']);
        },
    });
}
